// ============================================================================
// OBT — Bilgi talebini GERİ ÇEK (taslağa döndür) onay diyaloğu
// ============================================================================
// Backend sözleşmesi: POST /obt/campaigns/{id}/withdraw. Yayınlanmış ama HENÜZ
// CEVAP ALINMAMIŞ talebi taslağa indirir → yeniden düzenlenebilir. Cevap alınmışsa
// backend reddeder (o durumda "Arşivle" önerilir). Yetki backend'de yayın-anı
// immutable kaydından (yayınlayan ya da oluşturan) çözülür. Bu diyalog yalnız UX
// onayıdır; nihai yetki/kural kontrolü sunucudadır.
// ============================================================================

import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, Undo2 } from 'lucide-react';
import { withdrawCampaign } from './campaignApi';
import { normalizeObtError } from '../obtErrors';

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {{campaign_id:string, title?:string}|null} props.campaign
 * @param {() => void} props.onClose
 * @param {(campaignId:string) => void} [props.onWithdrawn]  Başarı sonrası (liste yenile / düzenleyiciye geç)
 */
export default function WithdrawCampaignDialog({ open, campaign, onClose, onWithdrawn }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setSubmitting(false);
      setError(null);
    }
  }, [open]);

  const handleWithdraw = async () => {
    if (!campaign?.campaign_id || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      const res = await withdrawCampaign(campaign.campaign_id);
      // Geri çekilen yayının hedefleri → düzenleyicide önceden seçili gelsin.
      if (onWithdrawn) onWithdrawn(campaign.campaign_id, res?.previous_target_ids || []);
      onClose();
    } catch (e) {
      setError(normalizeObtError(e));
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !submitting) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Bilgi talebini geri çek</DialogTitle>
          <DialogDescription>
            {campaign?.title ? `“${campaign.title}” bilgi talebi` : 'Bilgi talebi'}{' '}
            <strong>taslağa</strong> geri çekilecek ve yeniden düzenlenebilir olacak.
            Yayın (hedefler/parklar) kaldırılır; içerik, sorular ve geçmiş korunur.
            Düzenleyip <strong>yeniden yayınlayabilirsiniz</strong>. Bu işlem yalnız
            henüz <strong>hiç cevap alınmamış</strong> taleplerde yapılabilir; cevap
            alınmışsa bunun yerine <strong>Arşivle</strong>yin.
          </DialogDescription>
        </DialogHeader>

        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error.message || 'Bilgi talebi geri çekilemedi.'}
          </p>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={submitting}>
            Vazgeç
          </Button>
          <Button onClick={handleWithdraw} disabled={submitting}>
            {submitting ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
            ) : (
              <Undo2 className="mr-2 h-4 w-4" aria-hidden="true" />
            )}
            Geri çek ve düzenle
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
